// eslint-disable-next-line
import { h, Component } from 'preact';
import classNames from 'classnames';

import styles from './index.scss';

const preventDefault = e => e.preventDefault();
const id = x => x;

const SeButton = props => {
    const {
        isLink = false,
        externalPath = '#',
        secondary = true,
        block = false,
        disabled = false,
        onClick = null,
        children = null,
        extraClass = '',
        size = '',
    } = props;

    const btnClasses = classNames({
        [styles.btn]: true,
        [styles.small]: size === 'small',
        [styles.fullWidth]: block,
        [styles.primary]: !secondary,
        [styles.secondary]: secondary,
        [styles.disabled]: disabled,
        [extraClass]: true,
    });

    if (onClick) {
        return (
            <button className={btnClasses} onClick={onClick}>
                {children}
            </button>
        );
    }

    if (isLink) {
        const LinkComponent = 'a';
        const linkComponentProps = {
            href: disabled ? '#' : externalPath,
            onClick: disabled ? preventDefault : id,
        };

        return (
            <LinkComponent className={btnClasses} {...linkComponentProps}>
                {children}
            </LinkComponent>
        );
    }

    return <div className={btnClasses}>{children}</div>;
};

export default SeButton;
